import { CellClassParams, CellStyleFunc } from 'ag-grid-community'
import { RoleRow } from '../../model/RoleRow'
import { GRAYED_OUT_STYLE } from '../../../../containers/commons/AgGrid/cellStyle'

export const cellStyle: CellStyleFunc<RoleRow> = (
  params: CellClassParams<RoleRow>
) => {
  if (!params.data?.editable) {
    return GRAYED_OUT_STYLE
  }
  return undefined
}
